import { useMutation } from "@tanstack/react-query";
import { clientSignUp } from "@/api/v1-jwt/tenancy/tenancy";

export function useSignUpClient() {
  return useMutation({
    mutationFn: clientSignUp,
  });
}
